<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Pagination from "@/components/standard/hazardIdentification/hazardPagination2";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import EvaluacionImpactoPagination from "../../../components/standard/evaluacionImpacto/EvaluacionImpactoPagination.vue";
import evaluacionImpactoAPI from "../../../services/standards/evaluacionImpacto/evaluacionImpactoAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "2.11.1 Gestión del cambio",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    EvaluacionImpactoPagination,
  },
  data() {
    return {
      title:
        "2.11.1 Gestión del cambio",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "2.11.1 Gestión del cambio",
          active: true,
        },
      ],

      lista: [],
      loading: true,

      itemData: null,

      item: null,
      itemStatus: "No cumplido",
      deleteCount: 0,
      search: "",
      itemData: null,
      file: null,

      evaluacionImpacto: {
        type_change: null,
        description: null,
        file: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,
      nit: this.$store.getters["company/getCompany"].nit || null,
      lastId: 1,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
    };
  },

  validations: {
    evaluacionImpacto: {
      type_change: {
        required,
      },
      description: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(22)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page;
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 22)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status !== undefined ? response.status : this.itemStatus;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeItemStatus(itemStatus) {
      const itemChange = {
        companies_id: this.companyID,
        item_id: 22,
        status: itemStatus,
      };
      newScoresAPI.calculateScores(itemChange)
        .then((response) => {
          Swal.fire({
            title: "¡Éxito!",
            text: "¡Se ha cambiado el estado del ítem con éxito!",
            type: "success",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          setTimeout(() => window.location.reload(), 1000)
        })
        .catch((error) => {
          Swal.fire({
            title: "¡ERROR!",
            text: "¡No se ha actualizado el estado del ítem!",
            icon: "error",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });

          setTimeout(() => window.location.reload(), 1000)
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/2.11.1/${this.lastId}/${this.file.name}`;
        } else {
          url = `sst-prod/${this.nit}/2.11.1/${this.lastId}/${this.file.name}`;
        }
        const result = await uploadDocument(url, this.file);
        if (result) {
          this.evaluacionImpacto.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    async save() {
      this.submitted = true;
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        const data = {
          companies_id: this.companyID,
          description: this.evaluacionImpacto.description,
          file: this.evaluacionImpacto.file,
          type_change: this.evaluacionImpacto.type_change,
        };
        evaluacionImpactoAPI.save(data)
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 22,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.sendNotification(55, 22, true);
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha registrado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
              })
              .catch((error) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido registrar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido registrar!",
            icon: "warning",
            type: "warning",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    deleteEvaluacion(id) {
      evaluacionImpactoAPI.delete(id)
        .then((data) => {
          if (this.deleteCount > 0) {
            this.deleteCount -= 1;
          }
          const newStatus = this.deleteCount > 0 ? 'Pendiente' : 'No Cumplido';
          const itemChange = {
            companies_id: this.companyID,
            item_id: 22,
            status: newStatus,
          };
          newScoresAPI.calculateScores(itemChange)
            .then((response) => {
              this.loading = false
              Swal.fire({
                title: "Éxito!",
                text: "Se ha sido eliminado con Éxito!",
                icon: "success",
                type: "success",
                confirmButtonClass: "btn btn-confirm mt-2",
              });
              window.location.reload();
            })
            .catch((error) => {
              this.loading = false
              setTimeout(() => {
                Swal.fire({
                  title: "Error",
                  text: "¡No se ha podido registrar!",
                  icon: "error",
                  type: "error",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });
                window.location.reload();
              }, 1000);
              console.log(error);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getList() {
      evaluacionImpactoAPI
        .getAll(this.companyID)
        .then((response) => {
          this.loading = false;
          let identificacion = response.data.data;
          this.lista = identificacion;
          if (response.data.data[0]['id']) {
            this.lastId = response.data.data[0]['id'] + 1
          }
          if (Array.isArray(this.lista)) {
            this.deleteCount = this.lista.length;
          } else {
            this.deleteCount = 0;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    async print1() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/PROCEDIMIENTO_GUIA_GESTION_CAMBIO.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },

    async print2() {
      try {
        const url =
          "https://idmrnd3cibfs.compat.objectstorage.us-ashburn-1.oraclecloud.com/e-mision-sst/standards/FORMATO_GUIA_GESTION_CAMBIO.docx";
        window.location.href = url;
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.getItems();
    this.getList();
    this.getItemData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa deberá garantizar que evalúa los impactos que
                      la implementación de los cambios en la Seguridad y Salud
                      en el Trabajo, para esto, durante la planeación de los
                      cambios se deberá conformar un equipo de trabajo que
                      analice los peligros que se pueden presentar antes,
                      durante y después y generar acciones que permitan eliminar
                      o mitigar los efectos de estos peligros.
                    </p>
                    <p class="text-justify">
                      Se deberá diligenciar el formato de gestión del cambio y
                      subir las evidencias de la ejecución de las acciones.
                    </p>
                  </CheckModal>
                </div>

                <div class="form-row col-md-6 col-sm-12 pt-1">
                  <b-form-group id="statusInput" label-for="statusInput" class="col-sm-12" label="Estado del ítem">
                    <b-form-select v-on:change="changeItemStatus(itemStatus)"
                      :disabled="!getRole('Actualizar items', [1, 2, 3]) || !item || !allowAccess()" plain
                      class="selectpicker form-control" v-model="itemStatus">
                      <b-form-select-option value="Aprobado">Aprobado</b-form-select-option>
                      <b-form-select-option value="Pendiente">Pendiente</b-form-select-option>
                      <b-form-select-option value="No cumplido">No cumplido</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="row pt-3">
                <div class="col-8 text-right m-b-0"></div>
                <div class="col-4 text-right m-b-0 d-flex flex-column align-items-end">
                  <button :disabled="!allowAccess()" @click="print1" class="btn btn-primary mx-1 my-1">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Procedimiento guía para la gestión de cambios
                  </button>
                  <button :disabled="!allowAccess()" @click="print2" class="btn btn-primary mx-1 my-1">
                    <span class="btn-label">
                      <i class="bx bx-download"></i></span>
                    Formato guía para la gestión de los cambios
                  </button>
                </div>
              </div>

              <hr />

              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Tipo de cambio">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="evaluacionImpacto.type_change" :class="{
                        'is-invalid':
                          $v.evaluacionImpacto.type_change.$error && submitted,
                      }">
                      <b-form-select-option value="Infraestructura">
                        Infraestructura
                      </b-form-select-option>
                      <b-form-select-option value="Legislación">
                        Legislación
                      </b-form-select-option>
                      <b-form-select-option value="Procesos o proyectos">
                        Procesos o proyectos
                      </b-form-select-option>
                      <b-form-select-option value="Puestos de trabajo">
                        Puestos de trabajo
                      </b-form-select-option>
                      <b-form-select-option value="Tecnología">
                        Tecnología
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.evaluacionImpacto.type_change.$error
                    ">
                      <small v-if="!$v.evaluacionImpacto.type_change.required" class="text-danger">
                        <b>El tipo de cambio es requerido</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2 mb-3" label="Subir evidencia" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar" :placeholder="`Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile" v-on:change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document">
                    </b-form-file>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Breve descripción del cambio a realizar"
                    label-for="trainingDate">
                    <b-form-textarea :disabled="!allowAccess() || !getRole('Crear')" id="trainingDate"
                      v-model="evaluacionImpacto.description" maxlength="200" :class="{
                        'is-invalid':
                          $v.evaluacionImpacto.description.$error && submitted,
                      }">
                      >
                    </b-form-textarea>
                    <div v-if="submitted && $v.evaluacionImpacto.description.$error
                    ">
                      <small v-if="!$v.evaluacionImpacto.description.required" class="text-danger">
                        <b>La descripción es requerida</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">Guardar</button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">Cancelar</button>
                </div>

                <hr v-if="getRole('Consultar')" />

                <div class="row" v-if="getRole('Consultar') || !allowAccess()">
                  <div class="col-lg-12">
                    <div class="card-body">
                      <div class="row pb-3">
                        <div class="col-6">
                          <form @submit.prevent="fetch()" class="form-inline">
                            <div class="form-group mr-2">
                              <b-form-input type="text" name="search" id="search" v-model="search" @update="fetch()"
                                class="form-control px-2" placeholder="Buscar"></b-form-input>

                              <div class="col-1">
                                <button type="submit" class="btn btn-primary px-2">
                                  Buscar
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                        <div class="col-6"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded">
                          <thead>
                            <tr>
                              <th class="text-center align-middle">Fecha</th>
                              <th class="text-center align-middle">
                                Tipo de cambio
                              </th>
                              <th class="text-center align-middle">
                                Descripción
                              </th>
                              <th class="text-center align-middle">
                                Ver archivo
                              </th>
                              <th class="text-center align-middle">Acciones</th>
                            </tr>
                          </thead>
                          <tbody class="bg-white divide-y divide-gray-200">
                            <tr v-for="dato in lista" :key="dato.id">
                              <td class="text-center align-middle">
                                {{ dateConvert(dato.created_at) }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.type_change }}
                              </td>
                              <td class="text-center align-middle">
                                {{ dato.description }}
                              </td>

                              <td class="text-center align-middle">
                                <div v-if="dato.file === null">
                                  <h6>No hay archivo disponible</h6>
                                </div>
                                <div v-else>
                                  <button :disabled="!allowAccess()" style="
                                      background-color: transparent !important;
                                      border: none;
                                    " type="button" @click="gotoDigitalOcean(`${dato.file}`)">
                                    <i class="mdi mdi-cloud-download"></i>
                                  </button>
                                </div>
                              </td>

                              <td class="text-center align-middle">
                                <div class="col-sm-12">
                                  <b-dropdown :disabled="!allowAccess()" variant="primary">
                                    <template v-slot:button-content>
                                      <i class="mdi mdi-eye"></i>
                                    </template>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " :to="{
                                        path: `/forms/estandares/evaluacion-impacto-ver/${dato.id}`,
                                      }">
                                      Ver</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " v-b-modal="`modal${dato.id}`">Editar</b-dropdown-item>
                                    <b-dropdown-item :disabled="!getRole('Editar') || !allowAccess()
                                      " :to="{
                                        path: `/forms/estandares/gestion-cambio/${dato.id}`,
                                      }">
                                      Gestión del cambio</b-dropdown-item>

                                    <b-modal :id="`modal${dato.id}`" body-class="p-4" hide-header hide-footer size="sm">
                                      <div class="text-justify">
                                        <h4 class="mt-2 text-primary text-center">
                                          Advertencia
                                        </h4>
                                        <p class="mt-3">
                                          Al modificar esta información se
                                          quitará el puntaje correspondiente a
                                          este ítem y será necesario realizar
                                          nuevamente la validación por parte del
                                          usuario responsable de Emisión.
                                        </p>
                                        <button :disabled="!getRole('Editar') || !allowAccess()
                                          " type="button" class="btn btn-primary my-2 mx-2">
                                          <router-link class="text-white" :to="{
                                            path: `/forms/estandares/evaluacion-impacto-editar/${dato.id}`,
                                          }">Editar
                                          </router-link>
                                        </button>
                                        <button type="button" @click="
                                          $bvModal.hide(`modal${dato.id}`)
                                          " class="btn btn-danger btn mx-2" data-dismiss="modal">
                                          Cancelar
                                        </button>
                                      </div>
                                    </b-modal>
                                    <b-dropdown-item :disabled="!getRole('Eliminar') || !allowAccess()
                                      " v-on:click="deleteEvaluacion(dato.id)">Eliminar</b-dropdown-item>
                                  </b-dropdown>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <EvaluacionImpactoPagination ref="paginator" :search="search"
                          @fetch="(items) => (lista = items)" />
                      </div>
                    </div>
                  </div>
                  <!-- end col -->
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
